import React from "react";
import SitterCard from "./SitterCard";
import { Box } from "rebass/styled-components";
import {  ServiceType } from "../../interfaces";
import useTranslation from "next-translate/useTranslation";
import { Caregiver } from "../../generated/graphql";

interface Props {
  caregiver: Caregiver;
  serviceType: ServiceType;
  queryParams: any;
}

function SearchMapSitterCard({ caregiver, serviceType, queryParams }: Props) {
  const { t } = useTranslation("common");

  return (
    <Box
      sx={{
        width: "calc((100vw - 500px)/3)",
        minWidth: "300px",
        backgroundColor: "samoyedWhite"
      }}
    >
      <SitterCard
        slim
        name={caregiver.name!}
        headline={caregiver.caregiverHeadline!}
        avatar={caregiver?.avatar?.circle!}
        price={caregiver.price!}
        repeatCustomersCount={caregiver.repeatCustomersCount!}
        priceCurrency={caregiver.currency!}
        pricePer={serviceType && t(serviceType.pricePer!)}
        bookingEstimation={caregiver?.bookingEstimation!}
        reviewsCount={caregiver.caregiverReviewsCount!}
        reviewsScore={caregiver.caregiverReviewsScore!}
        completedBookingsCount={caregiver.caregiverCompletedBookingsCount!}
        slug={caregiver.slug!}
        queryParams={queryParams}
        address={caregiver.publicAddress!}
        hideHover={true}
        availablePromotions={caregiver?.availablePromotions!}
        city={caregiver.city}
        caregiverCalendarUpdatedAt={caregiver.caregiverCalendarUpdatedAt}
        reviews={caregiver.reviews}
        isSuperCaregiver={caregiver?.isSuperCaregiver}
        {...{
          css: {
            borderBottom: "none!important"
          }
        }}
        py={1}
        px={1}
      />
    </Box>
  );
}

export default SearchMapSitterCard;
